<template>
  <div class="Alert Alert--warning"><span>403, You don't have permission to view this page.</span></div>
</template>